import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import BlackSection from './components/BlackSection/BlackSection';
import PhotoCarousel from './components/PhotoCarousel/PhotoCarousel';
import WhiteSection from './components/WhiteSection/WhiteSection';
import ServicesSection from './components/ServicesSection/ServicesSection';
import VideoSection from './components/VideoSection/VideoSection';
import PortfolioSection from './components/PortfolioSection/PortfolioSection';
import ContactSection from './components/ContactSection/ContactSection';
import TestimonialSection from './components/TestimonialSection/TestimonialSection';
import Footer from './components/Footer/Footer';
import ScrollMenu from './components/ScrollMenu/ScrollMenu';
import CoreServicesSection from './components/CoreServicesSection/CoreServicesSection';
import BlogSection from './components/BlogSection/BlogSection';

// Lazy load gallery pages
const VideoGalleryPage = React.lazy(() => import('./components/VideoGalleryPage/VideoGalleryPage'));
const VideoReviewsPage = React.lazy(() => import('./components/VideoReviewsPage/VideoReviewsPage'));
const GalleryPage = React.lazy(() => import('./components/GalleryPage/GalleryPage'));
const WeddingGallery = React.lazy(() => import('./components/WeddingGallery/WeddingGallery'));
const PreWeddingGallery = React.lazy(() => import('./components/PreWeddingGallery/PreWeddingGallery'));
const RiceCeremonyGallery = React.lazy(() => import('./components/RiceCeremonyGallery/RiceCeremonyGallery'));
const BabyShowerGallery = React.lazy(() => import('./components/BabyShowerGallery/BabyShowerGallery'));
const JournalPage = React.lazy(() => import('./components/JournalPage/JournalPage'));
const AdminPanel = React.lazy(() => import('./components/AdminPanel/AdminPanel'));

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove the # symbol
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          // Small delay to ensure the page is fully loaded
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    };

    // Handle hash change on initial load
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div className="app">
      {!isAdmin && <ScrollMenu />}
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <BlackSection />
              <PhotoCarousel />
              <WhiteSection />
              <CoreServicesSection />
              <VideoSection />
              <PortfolioSection />
              <ServicesSection />
              <TestimonialSection />
              <BlogSection />
              <ContactSection />
            </div>
          }
        />
        <Route path="/video-gallery" element={
          <Suspense fallback={<div className="loading-fallback">Loading Video Gallery...</div>}>
            <VideoGalleryPage />
          </Suspense>
        } />
        <Route path="/video-reviews" element={
          <Suspense fallback={<div className="loading-fallback">Loading Video Reviews...</div>}>
            <VideoReviewsPage />
          </Suspense>
        } />
        <Route path="/gallery" element={
          <Suspense fallback={<div className="loading-fallback">Loading Gallery...</div>}>
            <GalleryPage />
          </Suspense>
        } />
        <Route path="/wedding-gallery" element={
          <Suspense fallback={<div className="loading-fallback">Loading Wedding Gallery...</div>}>
            <WeddingGallery />
          </Suspense>
        } />
        <Route path="/prewedding-gallery" element={
          <Suspense fallback={<div className="loading-fallback">Loading Pre-Wedding Gallery...</div>}>
            <PreWeddingGallery />
          </Suspense>
        } />
        <Route path="/rice-ceremony-gallery" element={
          <Suspense fallback={<div className="loading-fallback">Loading Rice Ceremony Gallery...</div>}>
            <RiceCeremonyGallery />
          </Suspense>
        } />
        <Route path="/baby-shower-gallery" element={
          <Suspense fallback={<div className="loading-fallback">Loading Baby Shower Gallery...</div>}>
            <BabyShowerGallery />
          </Suspense>
        } />
        <Route path="/journal" element={
          <Suspense fallback={<div className="loading-fallback">Loading Journal...</div>}>
            <JournalPage />
          </Suspense>
        } />
        <Route path="/admin" element={
          <Suspense fallback={<div className="loading-fallback">Loading Admin Panel...</div>}>
            <AdminPanel />
          </Suspense>
        } />
      </Routes>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
